'use strict';

var _ = require('lodash');
var RomSummaryController = function RomSummaryController($scope, $rootScope, dataService, constantsService, analysisMetricService, dataRetrieverService, BrushSelectionFilter, featureToggleService, optWeekReferenceService, currentStateCriteriaService, $q) {
  $scope.screen = constantsService.ROM_SUMMARY_SCREEN;
  $scope.mode = constantsService.ROM_SUMMARY_MODE;
  $scope.brushFilters = {};
  $scope.selectedFlowType = featureToggleService.isEnabled('MAPPED_MODE') ? 'REGULAR' : 'MAPPED';

  //set ROM_SUMMARY_MODE metrics
  dataRetrieverService.getDataRetriever($scope.screen, $scope.mode).updateMetricValues(analysisMetricService.getAnalysisMetric($scope.screen).getDefault());

  //set ROM_SUMMARY_REFERENCE_MODE metrics
  dataRetrieverService.getDataRetriever($scope.screen, constantsService.ROM_SUMMARY_REFERENCE_MODE).updateMetricValues(analysisMetricService.getAnalysisMetric($scope.screen).getDefault());
  $scope.charts = [{
    'grouping': 'cabin',
    'title': 'Cabin',
    'label': 'Cabins',
    'filterType': 'cabin'
  }, {
    'grouping': 'fullDow',
    'title': 'Day of Week',
    'label': 'Opt Day of Week',
    'filterType': 'dow'
  }, {
    'grouping': 'd2dBucket',
    'title': 'Days to Departure',
    'label': 'Days to Departure',
    'filterType': 'romTimeBucket'
  }, {
    'grouping': 'resType',
    'title': 'ResType',
    'label': 'ResType',
    'filterType': 'resType'
  }];
  if (featureToggleService.isEnabled('SPOS')) {
    $scope.charts.unshift({
      'grouping': 'pos',
      'title': 'Point of Sale',
      'label': 'Point of Sale',
      'filterType': 'pos'
    });
  }
  function clearBrushes() {
    $scope.brushFilters = {};
    dataRetrieverService.setBrushFilters($scope.brushFilters, $scope.screen);
    var defaultMetric = analysisMetricService.getAnalysisMetric(constantsService.ROM_SUMMARY_SCREEN).getDefault();
    dataRetrieverService.updateMetricValues(defaultMetric, constantsService.ROM_SUMMARY_SCREEN);
  }
  $scope.onSearchChangeEvent = function () {
    dataService.clearCache();
    $scope.setCustomSearchCriteria();
    optWeekReferenceService.startRetrievingOptWeekRefForRomSummaryScreen();
    clearBrushes();
  };
  $scope.brushFilterChanged = function (filter) {
    var metrics;
    if (filter.filterType === 'resType') {
      switch (filter.filterArguments[0][0]) {
        case 'Group':
          metrics = 'group';
          break;
        case 'Individual':
          metrics = 'individual';
          break;
        default:
          metrics = 'individualAndGrouped';
      }
      dataRetrieverService.updateMetricValues(metrics, constantsService.ROM_SUMMARY_SCREEN);
    }
    if (!filter.isEmpty()) {
      $scope.brushFilters[filter.filterType] = filter;
    } else {
      delete $scope.brushFilters[filter.filterType];
    }
    dataRetrieverService.setBrushFilters($scope.brushFilters, $scope.screen);
    $scope.$broadcast('brush-filter:filterApplied', filter);
  };
  function setCustomSearchCriteriaRules(rules, dataRetriever) {
    dataRetriever.setCustomSearchCriteriaRules($q.when(rules));
  }
  function prepareTopOppSearchCriteria(currentCriteria, dataRetriever) {
    var searchRules = _.cloneDeep(currentCriteria.rules);
    _.remove(searchRules, function (rule) {
      return rule.category === 'Location' || rule.category === 'Product';
    });
    setCustomSearchCriteriaRules(searchRules, dataRetriever);
  }
  $scope.setCustomSearchCriteria = function () {
    var dataRetrievers = dataRetrieverService.findDataRetrievers($scope.screen);
    var currentCriteria = currentStateCriteriaService.getCriteriaWithFlowType($scope.selectedFlowType);
    for (var i = 0, retrieversLength = dataRetrievers.length; i < retrieversLength; i++) {
      var dataRetriever = dataRetrievers[i];
      var dataRetrieverMode = dataRetriever._mode;
      if (dataRetrieverMode === 'rom-summary-top-opp-recap-mode' || dataRetrieverMode === 'rom-summary-top-opp-spill-mode') {
        prepareTopOppSearchCriteria(currentCriteria, dataRetriever);
      } else {
        setCustomSearchCriteriaRules(currentCriteria.rules, dataRetriever);
      }
    }
  };
  $scope.canKpiRibbonLoad = function (event) {
    if (event && event.name === 'search-criteria:searchChangeEvent') {
      return false;
    }
    var filters = dataRetrieverService.getDataRetriever($scope.screen, $scope.mode).brushFilters();
    return !(filters === undefined || filters['filter-component'] === undefined);
  };
  $scope.resetCharts = function () {
    clearBrushes();
    $scope.$broadcast('brush-filter:resetMainChart');
  };
  $scope.optWeekRefData = optWeekReferenceService.retrieveRomSummaryReferenceData;
  $scope.$on('search-criteria:searchChangeEvent', $scope.onSearchChangeEvent);
  $scope.$on('cog:romSummaryToolbar', function (event, cogOption) {
    $scope.selectedFlowType = cogOption.val[0];
    $scope.setCustomSearchCriteria();
    $scope.$broadcast($scope.screen + ':flowTypeChanged');
    $rootScope.$broadcast($scope.screen + '-' + $scope.mode + ':dimensionChanged');
  });
};
RomSummaryController.$inject = ['$scope', '$rootScope', 'DataService', 'DataRetrieverConstantsService', 'AnalysisMetricService', 'DataRetrieverService', 'BrushSelectionFilterFactory', 'FeatureToggleService', 'OptWeekReferenceService', 'CurrentStateCriteriaService', '$q'];
module.exports = RomSummaryController;